import ScrollBar from './ScrollBar';

export default ScrollBar;
